<template>
  <main class="w-full flex-grow p-6">
    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Banner (1440 px X 569 px)</div>
            <div @click="showModalExperience" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            <img
              :src="experience.banner"
              @click="showModal(experience.banner)"
              alt="23paskal"
              class="w-96 h-52 cursor-pointer"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Promotion</div>
            <div @click="showModalPromotion" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="">
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Title
              <div class="ml-8 font-normal">{{ promotion.title }}</div>
            </div>
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Description
              <!-- <div class="ml-8 font-normal">{{ promotion.description }}</div> -->
              <div
                class="ml-8 font-normal"
                v-html="promotion.description"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Destination</div>
            <div @click="showModalTenant" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="">
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Title
              <div class="ml-8 font-normal">{{ tenant.title }}</div>
            </div>
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Description
              <!-- <div class="ml-8 font-normal">{{ tenant.description }}</div> -->
              <div class="ml-8 font-normal" v-html="tenant.description"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Event</div>
            <div @click="showModalEvent" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="">
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Title
              <div class="ml-8 font-normal">{{ event.title }}</div>
            </div>
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Description
              <!-- <div class="ml-8 font-normal">{{ event.description }}</div> -->
              <div class="ml-8 font-normal" v-html="event.description"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal experience -->
    <div
      v-if="modalExperience"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalExperience"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">
            Banner (1440 px X 569 px)
          </div>
          <div class="p-6 flex-grow">
            <div
              class="border-dotted border-2 border-black p-2 rounded-lg"
              @drop="previewBanner"
            >
              <input
                type="file"
                accept="image/*"
                @change="previewBanner"
                id="banner"
                class="opacity-0 hidden"
              />
              <div class="flex flex-row">
                <div
                  v-if="update.previewBanner"
                  class="mr-1 relative rounded-lg w-full"
                >
                  <button
                    class="absolute right-2 top-2"
                    type="button"
                    @click="removeBannerFile"
                  >
                    <fas icon="trash-alt" class="text-red-600 text-3xl" />
                  </button>
                  <img
                    :src="update.previewBanner"
                    class="w-full h-80 rounded-lg"
                  />
                </div>
                <div
                  v-if="update.previewBanner === null"
                  v-cloak
                  @click="chooseBannerFile()"
                  class="w-full h-80 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                >
                  <fas icon="image" class="text-gray-600 text-3xl" />
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalExperience"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                :disabled="!update.previewBanner"
                @click="updateBannerExperience"
                type="button"
                class="text-gray-200 rounded px-4 py-2 w-32"
                :class="[!update.previewBanner ? 'bg-gray-500' : 'bg-blue-600']"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalExperience"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal promo -->
    <div
      v-if="modalPromotion"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalPromotion"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">
            Edit Promotion Description
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Title</label>
                <input
                  v-model="title"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200 mb-5"
                  placeholder="Title"
                />
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Description</label
                >
                <!-- <textarea
                  v-model="description"
                  rows="8"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200"
                  placeholder="Promo Description"
                ></textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200"
                >
                  <CKEditor
                    v-model="description"
                    :disabled="false"
                    :toolbar="toolbar"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ description?.length }} used out of 2000 characters
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalPromotion"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updatePromoInfo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalPromotion"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal tenant -->
    <div
      v-if="modalTenant"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalTenant"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">
            Edit Tenant Description
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Title</label>
                <input
                  v-model="title"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200 mb-5"
                  placeholder="Title"
                />
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Description</label
                >
                <!-- <textarea
                  v-model="description"
                  rows="8"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200"
                  placeholder="Promo Description"
                ></textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200"
                >
                  <CKEditor
                    v-model="description"
                    :disabled="false"
                    :toolbar="toolbar"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ description?.length }} used out of 2000 characters
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalTenant"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updateTenantInfo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalTenant"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal event -->
    <div
      v-if="modalEvent"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalEvent"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">
            Edit Event Description
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Title</label>
                <input
                  v-model="title"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200 mb-5"
                  placeholder="Title"
                />
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Description</label
                >
                <!-- <textarea
                  v-model="description"
                  rows="8"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200"
                  placeholder="Promo Description"
                ></textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200"
                >
                  <CKEditor
                    v-model="description"
                    :disabled="false"
                    :toolbar="toolbar"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ description?.length }} used out of 2000 characters
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalEvent"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updateEventInfo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalEvent"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <Modal
      v-show="isModalVisible"
      @close="closeModal"
      :imageso="imageso"
    /><Warning />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import CKEditor from "../../components/CKEditor.vue";
import Modal from "../../components/Modal.vue";
import Warning from "../../components/Warning.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "Information",
  components: {
    Modal,
    Warning,
    SuccessNotif,
    CKEditor,
  },
  data() {
    return {
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "|",
          "superscript",
          "subscript",
          "strikethrough",
          "|",
          "outdent",
          "indent",
          "alignment",
          "|",
          "undo",
          "redo",
        ],
      },
      imageso: "",
      isModalVisible: false,
      modalExperience: false,
      modalPromotion: false,
      modalTenant: false,
      modalEvent: false,
      experience: {},
      update: {
        previewBanner: null,
        fileBanner: null,
      },
      description: "",
      saveButton: "Save",
      promotion: {},
      tenant: {},
      event: {},
    };
  },
  methods: {
    showModal: function(data) {
      this.imageso = data;
      this.isModalVisible = true;
    },
    closeModal: function() {
      this.isModalVisible = false;
    },
    showModalExperience: function() {
      this.description = "";
      this.modalExperience = !this.modalExperience;
    },
    showModalPromotion: function() {
      this.title = this.promotion.title;
      this.description = this.promotion.description;
      this.modalPromotion = !this.modalPromotion;
    },
    showModalTenant: function() {
      this.title = this.tenant.title;
      this.description = this.tenant.description;
      this.modalTenant = !this.modalTenant;
    },
    showModalEvent: function() {
      this.title = this.event.title;
      this.description = this.event.description;
      this.modalEvent = !this.modalEvent;
    },
    previewBanner: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.update.previewBanner = e.target.result;
        };
        this.update.fileBanner = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    removeBannerFile: function() {
      this.update.previewBanner = null;
      this.update.fileBanner = null;
    },
    chooseBannerFile: function() {
      document.getElementById("banner").click();
    },
    updateBannerExperience: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("banner", this.update.fileBanner);
      formdata.append("id", this.experience.id);
      try {
        let res = await fetch(`${API}v1/experience/banner`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          this.modalExperience = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalExperience = false;
        this.findExperience();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.modalExperience = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    findExperience: async function() {
      try {
        let res = await fetch(`${API}v1/experience`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.experience = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    findPromotionInfo: async function() {
      try {
        let res = await fetch(`${API}v1/promotion-info`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.promotion = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    findTenantInfo: async function() {
      try {
        let res = await fetch(`${API}v1/destination-info`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.tenant = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    findEventInfo: async function() {
      try {
        let res = await fetch(`${API}v1/event-info`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.event = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    updatePromoInfo: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/promotion/info/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.promotion.id,
            title: this.title,
            description: this.description,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.saveButton = "Save";
        this.findPromotionInfo();
        this.modalPromotion = false;
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    updateTenantInfo: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/destination/info/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.tenant.id,
            title: this.title,
            description: this.description,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          this.saveButton = "Save";
          this.modalTenant = false;
          this._error(response.message);
          return;
        }
        this.saveButton = "Save";
        this.findTenantInfo();
        this.modalTenant = false;
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    updateEventInfo: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/event/info/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.event.id,
            title: this.title,
            description: this.description,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.saveButton = "Save";
        this.findEventInfo();
        this.modalEvent = false;
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findExperience();
    this.findPromotionInfo();
    this.findTenantInfo();
    this.findEventInfo();
  },
};
</script>
